'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'chevrons-up';
var width = 512;
var height = 512;
var aliases = ["chevron-double-up"];
var unicode = 'f325';
var svgPathData = 'M261.7 50.3L256 44.7l-5.7 5.7-208 208L36.7 264 48 275.3l5.7-5.7L256 67.3 458.3 269.7l5.7 5.7L475.3 264l-5.7-5.7-208-208zm0 192l-5.7-5.7-5.7 5.7-208 208L36.7 456 48 467.3l5.7-5.7L256 259.3 458.3 461.7l5.7 5.7L475.3 456l-5.7-5.7-208-208z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faChevronsUp = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;